import api from '@/api/Api'
import store from '@/store'
import cordovaModel from "@/model/CordovaModel";
import router, { asyncRouterMap, dynamicRouterMap, constantRouterMap } from '@/router';
import { recursionRouter, setDefaultRoute } from '@/assets/recursion-router'

/* 判断是否有权限 */
export function hasPermission(nameKey) {
    if(nameKey instanceof Array) {
        return nameKey.find(key=> hasPermission(key));
    }

    let permission = store.state.permission.permissionList;
    let permissionStatic = store.state.permission.staticPermissionList;
    if (nameKey == 'addGlobalEffectGroupTemplate' || nameKey == 'updateGlobalDefaultFlag'
        || nameKey == 'editGlobalEffectGroupTemplate' || nameKey == 'copyGlobalEffectGroupTemplate'
        || nameKey == 'deleteGlobalEffectGroupTemplate')
        return state.isSuperAdmin || (permission.indexOf(nameKey) > -1 && state.isDepartmentAdmin) || permissionStatic.indexOf(nameKey) > -1;
    else return state.isSuperAdmin || permission.indexOf(nameKey) > -1 || permissionStatic.indexOf(nameKey) > -1;
}
export function hasUserGroup() {
    let permission = store.state.permission.permissionList;
    let permissionStatic = store.state.permission.staticPermissionList;
    return store.state.user.userGroupList.length > 0 && (state.isSuperAdmin || permission.indexOf("selectShareGroupList") > -1 || permissionStatic.indexOf("selectShareGroupList") > -1);
}

/* 判断是否有平台权限 */
export function hasPlatformPermission(code) {
    let userPlatform = store.state.permission.userPlatformList;
    return userPlatform.indexOf(code) > -1;
}
const state = {
    routers: constantRouterMap,
    addRouters: [],
    staticPermissionList: cordovaModel.isCordova()?["200000"]:[], //静态权限
    permissionList: [],
    isDepartmentAdmin: false,
    isSuperAdmin: false
}
const getters = {

}
const mutations = {
    setPermission(state, {permissionList, isDepartmentAdmin, isSuperAdmin, userPlatformList}) {
        state.permissionList = permissionList;
        state.isDepartmentAdmin = isDepartmentAdmin;
        state.isSuperAdmin = isSuperAdmin;
        state.userPlatformList = userPlatformList;
    }
}
const actions = {
    async FETCH_PERMISSION({ commit }) {
        /*  获取后台给的权限数组 */
         try {
             let ret = await api.call("user/getUserPermissionList");
             commit("setPermission", {
                permissionList: ret.list.map(node => node.nameKey),
                isDepartmentAdmin: ret.isAdmin,
                isSuperAdmin: ret.isSuper,
                userPlatformList: ret.userPlatformList.map(i => i.code)
             })
         } catch (e) {
             console.log(e)
         }
         
        /*  根据后台权限跟我们定义好的权限对比，筛选出对应的路由并加入到path='user'的children */
        /*过滤出动态路由*/
        let permissionList = [];
        permissionList = permissionList.concat(state.permissionList);
        permissionList = permissionList.concat(state.staticPermissionList);
       let routes = recursionRouter(permissionList, asyncRouterMap, state.isDepartmentAdmin, state.isSuperAdmin);

        /*找到需要设置动态路由的节点user*/
        let MainContainer = dynamicRouterMap[0];

        /*找到user节点下的children*/
        let children = MainContainer.children;

        // 把动态生成的路由插入user节点下的children数组
        for(let item in routes){
            children.push(routes[item]);
        }

        /*设置进入页面后默认显示的路由*/
        setDefaultRoute([MainContainer]);

        /*  动态添加路由 */
        router.addRoutes(dynamicRouterMap);

    },
    async clearPermissionList(){
        state.permissionList = [];
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}